import { render, staticRenderFns } from "./BscCostDetail.vue?vue&type=template&id=3e030873&scoped=true"
import script from "./BscCostDetail.vue?vue&type=script&lang=js"
export * from "./BscCostDetail.vue?vue&type=script&lang=js"
import style0 from "./BscCostDetail.vue?vue&type=style&index=0&id=3e030873&prod&scoped=true&lang=css"
import style1 from "./BscCostDetail.vue?vue&type=style&index=1&id=3e030873&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e030873",
  null
  
)

export default component.exports